import { create } from "zustand";
import authApiClient from "../api/api.auth";
import { enqueueSnackbar } from "notistack";
import { throwError } from "../hooks/useErrorHandler";
import { PepStore, PepAgreement } from "../types/Store/PepStore.types";

export const usePepStore = create<PepStore>()((set, get) => ({
    agreement: null,
    loading: false,

    async loadAgreement(): Promise<PepAgreement | null> {
        try {
            set({ loading: true });
            const { data } = await authApiClient.get("/api/v1/user/pep-agreement");
            const agreement = data as PepAgreement;
            set({ agreement });
            return agreement;
        } catch (error) {
            throwError(error);
            return null;
        } finally {
            set({ loading: false });
        }
    },

    async accept(): Promise<boolean> {
        try {
            await authApiClient.post("/api/v1/user/pep-agreement/accept");
            const prev = get().agreement;
            if (prev) set({ agreement: { ...prev, accepted: true } });
            enqueueSnackbar({ message: "Соглашение принято", variant: "success" });
            return true;
        } catch (error) {
            throwError(error);
            return false;
        }
    },

    isAccepted(): boolean {
        return Boolean(get().agreement?.accepted);
    },

    reset() {
        set({ agreement: null, loading: false });
    },
}));
